import useLanguage from "../../i18n/useLanguage";
import { aiUseCases } from "../../data/ai-service";

export default function AiUseCases() {
  const { t } = useLanguage();
  return (
    <section aria-labelledby="ai-use-cases" className="py-14">
      <h2 id="ai-use-cases" className="text-3xl sm:text-4xl font-bold mb-8">{t("Konten untuk kebutuhanmu")}</h2>
      <div className="grid md:grid-cols-2 gap-6">
        {aiUseCases.map(item => <article key={item.title} className="rounded-2xl border border-white/10 bg-neutral-950 p-7"><h3 className="text-xl font-bold text-amber-300 mb-3">{t(item.title)}</h3><p className="text-gray-400 leading-relaxed">{t(item.text)}</p></article>)}
      </div>
    </section>
  );
}
